import cepAlternativeApi from '../../../configs/cepAlternativeApi';
import cepAlternativeApi3 from '../../../configs/cepAlternativeApi3';
import cepApi from '../../../configs/cepApi';
import api from '../../../configs/instanceApi';

export const getAddressByCep = (cep) => {
  const url = `/places/address?zipCode=${cep}`;
  return api.get(url, cep);
};

export const getAddressByCepAlternative = (cep) => {
  const url = `/${cep}/json/`;
  return cepApi.get(url, cep);
};

export const getAddressByCepAlternative2 = (cep) => {
  const url = `/${cep}.json`;
  return cepAlternativeApi.get(url, cep);
};

export const getAddressByCepAlternative3 = (cep) => {
  const url = `/${cep}`;
  return cepAlternativeApi3.get(url, cep);
};

export const sendAddresses = (ecIdentity, addresses, recaptchaToken = '') => {
  const url = `/accreditation-quotations/quotations/${ecIdentity}/addresses`;
  const config = {
    headers: {}
  };

  if (recaptchaToken) {
    config.headers['X-Recaptcha-Token'] = recaptchaToken;
  }

  return api.patch(url, addresses, config);
};
